import { Select, Translate } from "ol/interaction";
import { BaseInteraction } from "../../lib/interaction/interactions";
import { degrees, GeocodeMessage } from "../messages/GeocodeMessage";
import { ToolMessage } from "../messages/ToolMessage";
export class BldMoveInteraction extends BaseInteraction {
    constructor(map, layer) {
        super();
        this.map = map;
        this.layer = layer;
        this.handle_other_messages = (e) => { };
        this.angle_to_rads = (angle) => angle * (Math.PI / 180);
        this.start_angle_rads = 0;
        this.deltaX = 0;
        this.deltaY = 0;
        this.name = 'bld_move';
        this.set('edited', []);
        this.set('bld_parts', []);
    }
    init() {
        this.create_interactions();
        let highest_z = this.map.get_highest_z() + 1;
        this.layer.raw.setZIndex(highest_z);
        new ToolMessage({ selected: true, tool: this.name, command: "TOOL SELECTION" }).send;
        window.addEventListener('message', this.handle_other_messages);
    }
    remove() {
        this.layer.remove();
        super.remove();
        $('#rotate-container').addClass('hidden');
        new ToolMessage({ selected: false, tool: this.name, command: "TOOL SELECTION" }).send();
        window.removeEventListener('message', this.handle_other_messages);
        if ($('.toolBar').hasClass('hidden')) {
            $('.toolBar').removeClass('hidden');
        }
    }
    save() {
        this.remove();
        let edited = this.get('edited');
        if (edited.length > 0) {
            for (let b of edited.filter((e, i, a) => a.findIndex(x => x.get('bld_id') === e.get('bld_id')) === i)) {
                new GeocodeMessage({
                    command: 'GEOCODE',
                    parcel_id: b.get('parcel_id'),
                    bld_id: b.get('bld_id'),
                    first_point: b.get('first_point'),
                    rotation: degrees(b.get('rotation')),
                    flip: b.get('flip')
                }).send();
            }
            this.set('edited', []);
        }
    }
    cancel() {
        this.remove();
        this.set('edited', []);
    }
    create_interactions() {
        let select = new Select({
            layers: [this.layer.raw]
        });
        let drag = new Translate({
            features: select.getFeatures()
        });
        select.on('select', (evt) => {
            this.select_handler(evt);
            const bld_parts = this.get('bld_parts');
            select.getFeatures().clear();
            select.getFeatures().extend(bld_parts);
        });
        drag.on('translateend', this.drag_handler.bind(this));
        this.interactions.push(select, drag);
    }
    select_handler(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        let ids = evt.selected.map(b => b.get('bld_id'));
        if (ids.length === 0)
            return;
        let id = ids[0];
        let bld_parts = this.layer.buildings.filter(b => b.get('bld_id') === id);
        this.set('bld_parts', bld_parts);
        let bld = this.layer.features.find(b => b.getKeys().includes('first_point'));
        if (!bld) {
            bld = this.layer.buildings.find(b => b.getKeys().includes('first_point'));
            if (!bld)
                return;
        }
        bld.set('orig_first_point', bld.get('first_point'));
        $('#rotate-container').removeClass('hidden');
        this.rotate_control();
    }
    drag_handler(evt) {
        let bld = evt.features.getArray().find(b => b.getKeys().includes('first_point'));
        if (!bld)
            return;
        let start = evt.startCoordinate;
        let end = evt.coordinate;
        this.deltaX += end[0] - start[0];
        this.deltaY += end[1] - start[1];
        let origin = bld.get('orig_first_point');
        if (origin[0] === 0 || origin[1] === 0) {
            const bld_polygon = bld.getGeometry();
            const all_coords = bld_polygon.getCoordinates()[0];
            const first_coord = all_coords[0];
            bld.set('first_point', [Math.round(first_coord[0]), Math.round(first_coord[1])]);
        }
        else {
            bld.set('first_point', [Math.round(origin[0] + this.deltaX), Math.round(origin[1] + this.deltaY)]);
        }
        this.get('edited').push(bld);
        this.translate_rotate();
    }
    rotate_control() {
        if (this.get('bld_parts').length === 0)
            return;
        this.start_angle_rads = 0;
        this.deltaX = 0;
        this.deltaY = 0;
        const bld_parts = this.get('bld_parts');
        bld_parts.forEach(f => f.set('orig_geometry', f.getGeometry().clone()));
        const current_angle = bld_parts.find(b => b.getKeys().includes('rotation'));
        let current_angle_deg = 0;
        if (current_angle) {
            current_angle_deg = current_angle.get('rotation');
            this.start_angle_rads = this.angle_to_rads(current_angle_deg);
        }
        $('#rotate-input')
            .val(current_angle_deg)
            .on('input', () => {
            this.translate_rotate();
            let primary_bld_section = bld_parts.find(b => b.getKeys().includes('rotation'));
            if (!primary_bld_section)
                return;
            primary_bld_section.set('rotation', $('#rotate-input').val());
            this.get('edited').push(primary_bld_section);
        });
        $('#bld-move-cancel').on('click', () => {
            this.cancel();
        });
        $('#bld-move-save').on('click', () => {
            this.save();
        });
    }
    translate_rotate() {
        let angle_shift = this.start_angle_rads - this.angle_to_rads($('#rotate-input').val());
        const bld_parts = this.get('bld_parts');
        bld_parts.forEach(f => {
            const geom = f.get('orig_geometry');
            const clone = geom.clone();
            clone.translate(this.deltaX, this.deltaY);
            clone.rotate(angle_shift, this.get_start_point());
            f.setGeometry(clone);
        });
    }
    get_start_point() {
        let bld_parts = this.get('bld_parts');
        const start_section = bld_parts.find(b => b.getKeys().includes('first_point'));
        if (!start_section)
            throw new Error("Building did not have a start point.");
        const start_point = start_section.get('first_point');
        return start_point;
    }
}
